export default "__VITE_ASSET__TWXh17Py__"